/**
 * @file 产品全景
 * @author wanzhongyun
 */

import React from 'react';
import {Button} from 'antd';
import Header from '../../components/header/HeaderWithStore';
import Banner from '../../components/banner/Banner';
import Footer from '../../components/footer/Footer';
import ProductScenePreview from './components/product-scene-preview/ProductScenePreview';
import useOverviewHooks from './overviewHooks';
import IconTextList from './components/icon-text-card/IconTextList';
import TextCards from './components/text-cards/TextCards';

const Overview: React.FC = () => {
    const {
        banner,
        productPreview,
        learnTextCard
    } = useOverviewHooks();

    return (
        <div className="page paddle-pp-page">
            {
                banner?.title && <div>
                    <Header />
                    {!!banner
                    && (
                        <Banner
                            title={banner.title}
                            subtitle={banner.subtitle}
                            divider
                        >
                            <div className="paddle-pp-page-banner-btn-group">
                                {banner.btns?.map((btn: any) => (
                                    <a
                                        key={`${btn.label}${btn.href}`}
                                        href={btn.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <Button
                                            type="primary"
                                            size="large"
                                            className="paddle-pp-page-banner-btn"
                                        >
                                            {btn.label}
                                        </Button>
                                    </a>
                                ))}
                            </div>
                        </Banner>
                    )}

                    <div className="paddle-pp-content">
                        {!!productPreview
                        && (
                            <>
                                <div className="paddle-pp-content-h2">
                                    {productPreview.title}
                                </div>
                                <div className="paddle-pp-content-h3"
                                    {...{dangerouslySetInnerHTML:{__html: productPreview.subtitle}}}
                                >
                                </div>
                                <div className="paddle-pp-content-right">
                                    <div className="paddle-pp-product-scene-preview-title">
                                        Auxiliary Tools
                                    </div>
                                    <IconTextList {...productPreview} />
                                </div>

                                <div className="paddle-pp-content-center">
                                    <div className="paddle-pp-product-scene-preview-title">
                                        Main Process
                                    </div>
                                    <ProductScenePreview {...productPreview} />
                                </div>
                            </>
                        )}

                        {!!learnTextCard
                        && (
                            <>
                                <div className="paddle-pp-content-h2">
                                    {learnTextCard.title}
                                </div>
                                <div className="paddle-pp-content-h4">
                                    {learnTextCard.subtitle}
                                </div>
                                <TextCards {...learnTextCard} />
                            </>
                        )}
                    </div>
                    <Footer />
                </div>
            }
        </div>
    );
};

export default Overview;
